var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconInfoBlue = function SvgIconInfoBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.75c5.66 0 10.25 4.59 10.25 10.25S17.66 22.25 12 22.25 1.75 17.66 1.75 12 6.34 1.75 12 1.75Zm.016 2.228-.303.007A7.98 7.98 0 0 0 6.36 6.364a7.97 7.97 0 0 0 5.623 13.658 7.98 7.98 0 0 0 5.655-2.386 7.97 7.97 0 0 0-5.32-13.653l-.303-.005ZM12 10.333c.776 0 1.405.63 1.405 1.405v4.578a1.405 1.405 0 1 1-2.81 0v-4.578c0-.776.629-1.405 1.405-1.405Zm0-4.038a1.639 1.639 0 1 1 0 3.278 1.639 1.639 0 0 1 0-3.278Z",
    fill: "#1B75E2",
    fillRule: "evenodd"
  })));
};

export default SvgIconInfoBlue;